/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import OddButton from "../OddButton/oddbutton";
import BetPlacing from "../BetPlacing/BetPlacing";
import { connectSportMarketStandard } from "./SportMarketStandard.connect";
import Marquee from "react-fast-marquee";
// import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  getCurrencyFormat,
  getCurrencyFormatRoundedOff,
} from "../../helpers/getCurrencyFormat.helper";
import SVG_StopWatchtIcon from "../../assets/images/svgs/stopwatch-timer.svg?react";
import SVG_LadderIcon from "../../assets/images/svgs/ladder.svg?react";

const SportMarketStandard = ({
  data,
  betPlacing,
  exposure,
  exposureFancy,
  actions,
  isRacing = false,
  elementsParams,
  openBets,
  cashoutPopUp,
  sportLimits,
  selectedRaces = [],
  setSelectedRaces,
  inplay,
}) => {
  const [showInfo, setShowInfo] = useState(false);
  const [cashOutData, setCashData] = useState(0);
  const betDelayData = useSelector((state) => state.sportEvent?.betDelay);

  const isFancy = data?.fancy_id;
  const width =
    elementsParams && elementsParams?.clientWidth
      ? elementsParams?.clientWidth
      : window.innerWidth;

  const [clicked, setClicked] = useState(null);

  const calculateExposure = (runnerId) => {
    let number = 0,
      calced;

    const pnlId = data.market_id;
    if (exposure && exposure && exposure[pnlId]) {
      let findNumber = exposure[pnlId]?.filter(
        (item) => item.selection_id == runnerId,
      );
      number = findNumber[0].user_pl;
    }
    if (betPlacing.market === data.market_id) {
      if (betPlacing.runner === runnerId) {
        if (betPlacing.isBack) {
          const profit = isFancy
            ? betPlacing.stake
            : (
                betPlacing.stake * betPlacing.priceActual -
                betPlacing.stake
              ).toFixed(2);
          calced = (isFancy ? 0 : number) + Number(profit) * (isFancy ? -1 : 1);
        } else {
          const profit = isFancy
            ? betPlacing.stake * (betPlacing.priceActual / 100)
            : (
                betPlacing.stake * betPlacing.priceActual -
                betPlacing.stake
              ).toFixed(2);
          calced = (isFancy ? 0 : number) + Number(profit) * -1;
        }
      } else {
        calced = betPlacing.isBack
          ? number - Number(betPlacing.stake)
          : number - Number(betPlacing.stake) * -1;
      }
    }

    if (number) return number;
  };

  const cashOut = (market) => {
    let greenAmount = 0;
    let redAmount = 0;
    let currentlaygrrenodds = 0;
    let runners;
    let runners_point = [];
    const isBook = market?.market_type.includes("BOOKMAKER");

    for (var i = 0; i < market?.runners?.length; i++) {
      if (
        calculateExposure(market.runners[0].selectionId) > 0 &&
        calculateExposure(market.runners[1].selectionId) > 0
      ) {
        if (
          calculateExposure(market.runners[0].selectionId) >
          calculateExposure(market.runners[1].selectionId)
        ) {
          greenAmount = calculateExposure(market.runners[0].selectionId);
          currentlaygrrenodds = isBook
            ? market.runners[0]?.ex?.availableToLay[0]?.price / 100 + 1
            : market.runners[0]?.ex?.availableToLay[0]?.price;

          runners = market.runners[0];
          runners_point.push(greenAmount);
          redAmount = calculateExposure(market.runners[1].selectionId);
          runners_point.push(redAmount);
        } else {
          greenAmount = calculateExposure(market.runners[1].selectionId);
          currentlaygrrenodds = isBook
            ? market.runners[1]?.ex?.availableToLay[0]?.price / 100 + 1
            : market.runners[1]?.ex?.availableToLay[0]?.price;

          runners = market.runners[1];
          runners_point.push(greenAmount);
          redAmount = calculateExposure(market.runners[0].selectionId);
          runners_point.push(redAmount);
        }
      } else {
        if (calculateExposure(market.runners[i].selectionId) >= 0) {
          greenAmount = calculateExposure(market.runners[i].selectionId);
          currentlaygrrenodds = isBook
            ? market.runners[i]?.ex?.availableToLay[0]?.price / 100 + 1
            : market.runners[i]?.ex?.availableToLay[0]?.price;
          runners = market.runners[i];
          runners_point.push(greenAmount);
        } else {
          redAmount = calculateExposure(market.runners[i].selectionId);
          runners_point.push(redAmount);
        }
      }
    }

    let layStake = 0;

    const difference = Number(greenAmount || 0) - Number(redAmount || 0);

    if (currentlaygrrenodds && isFinite(currentlaygrrenodds)) {
      if (market?.market_type?.includes("BOOKMAKER")) {
        layStake = difference / currentlaygrrenodds;
      } else {
        layStake = difference / currentlaygrrenodds;
      }
    }

    // prevent negative / infinity
    layStake = Math.abs(layStake);

    if (!isFinite(layStake) || isNaN(layStake)) {
      layStake = 0;
    }

    if (!runners) {
      if (Math.trunc(runners_point[0]) == Math.trunc(runners_point[1])) {
        return;
      }
      if (runners_point[0] > runners_point[1]) {
        runners = market.runners[0];
        greenAmount = calculateExposure(market.runners[0].selectionId);
        currentlaygrrenodds = isBook
          ? market?.runners[i]?.ex?.availableToLay?.[0]?.price ||
            market?.runners[i]?.ex?.availableToBack?.[0]?.price
          : market.runners[0]?.ex?.availableToLay[0]?.price;
        redAmount = calculateExposure(market.runners[1].selectionId);
      } else {
        runners = market.runners[1];
        greenAmount = calculateExposure(market.runners[1].selectionId);
        currentlaygrrenodds = isBook
          ? Number(market.runners[1]?.ex?.availableToLay[0]?.price) / 100 + 1
          : market.runners[1]?.ex?.availableToLay[1]?.price;

        redAmount = calculateExposure(market.runners[0].selectionId);
      }
    }

    if (layStake === Infinity) {
      layStake = (greenAmount - redAmount) / currentlaygrrenodds;
    }

    actions.setMarket(market.market_id);
    actions.setRunner(runners.selectionId);
    actions.setRunnerName(runners.name);
    actions.setEventName(market && market.market_name);
    actions.setIsBack(false);
    actions.setPrice(runners.ex.availableToLay[0].price);
    actions.setPriceActual(runners.ex.availableToLay[0].price);
    actions.setLine(isFancy);
    actions.setStake(Math.floor(layStake) ?? 0);
  };

  const sendCahsOutRequest = (marketId, delay) => {
    cashOut(marketId);
    actions.setDelay(betDelayData?.market_bet_delay);

    // actions.setCashOutId(marketId.marketId)
    // actions.setIsCashOut(true)
    // actions.setBetPlacingPopoverStage(false)
    // actions.setShowBetPlacingPopover(true)

    actions.setIsCashOutPopup({ isOpen: true, market: marketId });
  };

  const compareNumbers = (num0, num1) => {
    if (num0 > num1) {
      return 1;
    } else if (num0 < num1) {
      return 0;
    }
  };

  const cashOutShown = async (market) => {
    let greenAmount = 0;
    let redAmount = 0;
    let currentlaygrrenodds = 0;
    let runners;
    let runners_point = [];

    for (var i = 0; i < market?.runners?.length; i++) {
      const exposureValue = Number(
        calculateExposure(market?.runners[i]?.selectionId) || 0,
      );

      if (
        calculateExposure(market?.runners[0]?.selectionId) > 0 &&
        calculateExposure(market?.runners[1]?.selectionId) > 0
      ) {
        if (
          calculateExposure(market?.runners[0]?.selectionId) >
          calculateExposure(market?.runners[1]?.selectionId)
        ) {
          greenAmount = Number(
            calculateExposure(market?.runners[0]?.selectionId) || 0,
          );

          currentlaygrrenodds = market?.market_type?.includes("BOOKMAKER")
            ? market?.runners[0]?.ex?.availableToLay?.[0]?.price ||
              market?.runners[0]?.ex?.availableToBack?.[0]?.price
            : market?.runners[0]?.ex?.availableToLay?.[0]?.price;

          runners = market?.runners[0];

          runners_point.push(greenAmount);

          redAmount = Number(
            calculateExposure(market?.runners[1]?.selectionId) || 0,
          );

          runners_point.push(redAmount);
        } else {
          greenAmount = Number(
            calculateExposure(market?.runners[1]?.selectionId) || 0,
          );

          currentlaygrrenodds = market?.market_type?.includes("BOOKMAKER")
            ? market?.runners[1]?.ex?.availableToLay?.[0]?.price ||
              market?.runners[1]?.ex?.availableToBack?.[0]?.price
            : market?.runners[1]?.ex?.availableToLay?.[0]?.price;

          runners = market?.runners[1];

          runners_point.push(greenAmount);

          redAmount = Number(
            calculateExposure(market?.runners[0]?.selectionId) || 0,
          );

          runners_point.push(redAmount);
        }
      } else {
        if (exposureValue >= 0) {
          greenAmount = exposureValue;

          currentlaygrrenodds = market?.market_type?.includes("BOOKMAKER")
            ? market?.runners[i]?.ex?.availableToLay?.[0]?.price ||
              market?.runners[i]?.ex?.availableToBack?.[0]?.price
            : market?.runners[i]?.ex?.availableToLay?.[0]?.price;

          runners = market?.runners[i];

          runners_point.push(greenAmount);
        } else {
          redAmount = exposureValue;
          runners_point.push(redAmount);
        }
      }
    }

    // ✅ FIX stake logic
    let layStake = 0;

    const difference = Number(greenAmount) - Number(redAmount);
    const price = Number(currentlaygrrenodds || 0);

    if (price > 0) {
      if (market?.market_type?.includes("BOOKMAKER")) {
        layStake = difference / (price / 100 + 1);
      } else {
        layStake = difference / price;
      }
    }

    layStake = Math.abs(layStake);

    if (!isFinite(layStake) || isNaN(layStake)) {
      layStake = 0;
    }

    if (!runners) {
      if (Math?.trunc(runners_point[0]) == Math?.trunc(runners_point[1])) {
        return;
      }

      if (runners_point[0] > runners_point[1]) {
        runners = market?.runners[0];
        currentlaygrrenodds =
          market?.runners[0]?.ex?.availableToLay?.[0]?.price;
      } else {
        runners = market?.runners[1];

        // ❌ removed wrong [1] index
        currentlaygrrenodds =
          market?.runners[1]?.ex?.availableToLay?.[0]?.price;
      }
    }

    const betData = {
      market: market?.market_id,
      runner: runners?.selectionId,
      isBack: false,
      stake: Math.floor(layStake),
      priceActual: market?.market_type?.includes("BOOKMAKER")
        ? runners?.ex?.availableToLay?.[0]?.price ||
          runners?.ex?.availableToBack?.[0]?.price
        : runners?.ex?.availableToLay?.[0]?.price,
    };

    return betData;
  };

  const cashoutExposure = async (runnerId, isIndex) => {
    let betPlacingData = await cashOutShown(data);

    let number = 0,
      calced = 0;

    const pnlId = data.market_id;

    if (exposure && exposure[pnlId]) {
      let findNumber = exposure[pnlId]?.filter(
        (item) => item.selection_id == runnerId,
      );

      number = Number(findNumber?.[0]?.user_pl || 0);
    }

    if (betPlacingData?.market === data.market_id) {
      if (betPlacingData.runner === runnerId) {
        const stake = Number(betPlacingData.stake || 0);
        const price = Number(betPlacingData.priceActual || 0);

        if (betPlacingData.isBack) {
          let profit;

          if (isFancy) {
            profit = stake;
          } else if (data?.market_type.includes("BOOKMAKER")) {
            // ✅ FIXED BOOKMAKER PROFIT
            profit = stake * (price - 1);
          } else {
            profit = stake * price - stake;
          }

          calced = (isFancy ? 0 : number) + profit * (isFancy ? -1 : 1);
        } else {
          let profit;

          if (isFancy) {
            profit = stake * (price / 100);
          } else if (data?.market_type.includes("BOOKMAKER")) {
            // ✅ FIXED BOOKMAKER PROFIT
            profit = stake * (price - 1);
          } else {
            profit = stake * price - stake;
          }

          calced = (isFancy ? 0 : number) - profit;
        }
      } else {
        const stake = Number(betPlacingData.stake || 0);

        calced = betPlacingData.isBack ? number - stake : number + stake; // fixed sign
      }
    }

    // ✅ FIXED RETURN CONDITION
    if (isIndex) return calced ?? 0;

    return number ?? 0;
  };

  useEffect(() => {
    const getCashoutData = async () => {
      let cashoutValue = await calculateprofiltlossCashout(data);
      setCashData(Math.floor(cashoutValue));
    };
    const isTwoRunnerMarket =
      data?.runners?.length === 2 &&
      ["MATCH_ODDS", "BOOKMAKER"].includes(data?.market_type);

    if (isTwoRunnerMarket) {
      getCashoutData();
    }
  }, [data]);

  const calculateprofiltlossCashout = async (market) => {
    if (market?.runners?.length !== 2) {
      return 0;
    }

    let firstRunner = await cashoutExposure(market?.runners[0]?.selectionId);
    let secondRunner = await cashoutExposure(market?.runners[1]?.selectionId);

    if (Math.floor(firstRunner) === Math.floor(secondRunner)) {
      return 0;
    }

    let findindex = compareNumbers(firstRunner, secondRunner);

    let indexRunner = await cashoutExposure(
      market?.runners[findindex]?.selectionId,
      true,
    );
    if (indexRunner) {
      return indexRunner;
    } else {
      return 0;
    }
  };

  const addMarketData = (market) => {
    // Check if market_id already exists in state
    const marketExists = selectedRaces.some(
      (item) => item.selectionId === market.selectionId,
    );

    if (
      !marketExists &&
      selectedRaces.length < 4 &&
      data?.status !== "SUSPENDED" &&
      market?.status === "ACTIVE"
    ) {
      // If it doesn't exist, add the new data to the array
      setSelectedRaces &&
        setSelectedRaces((prevMarkets) => [
          ...prevMarkets,
          {
            ...market,
            match_id: data.match_id,
            match_name: data.match_name,
            match_date: data.match_date,
            market_id: data.market_id,
            name: data.name,
            market_name: data.market_name,
            market_type: data.market_type,
          },
        ]);
    } else {
      setSelectedRaces &&
        setSelectedRaces((prevMarkets) =>
          prevMarkets.filter((item) => item.selectionId !== market.selectionId),
        );
    }
  };

  const renderOdds = (item, runner) => {
    const transformData = (data) => {
      const result = {};

      for (let i = 2; i >= 0; i--) {
        if (data?.ex?.availableToBack) {
          result[`back${i}`] = {
            price: data?.ex?.availableToBack[`${i < 0 ? "" : i}`]?.price,
            oprice: data?.ex?.availableToBack[`${i < 0 ? "" : i}`]?.oprice,
            size: data?.ex?.availableToBack[`${i < 0 ? "" : i}`]?.size,
          };
        } else {
          result[`back${i}`] = {
            price: undefined,
            oprice: undefined,
            size: undefined,
          };
        }

        if (data?.ex?.availableToLay) {
          result[`lay${i}`] = {
            price: data?.ex?.availableToLay[`${i < 0 ? "" : i}`]?.price,
            oprice: data?.ex?.availableToLay[`${i < 0 ? "" : i}`]?.oprice,
            size: data?.ex?.availableToLay[`${i < 0 ? "" : i}`]?.size,
          };
        } else {
          result[`lay${i}`] = {
            price: undefined,
            oprice: undefined,
            size: undefined,
          };
        }
      }

      return result;
    };
    const matchOddData = transformData(item);
    const isMarketSuspended =
      data?.status == "SUSPENDED" || data?.status == "REMOVED";
    const isRunnerSuspended =
      item?.status == "SUSPENDED" || item?.status == "REMOVED";

    const status = isFancy
      ? item?.is_active === 1
        ? "OPEN"
        : item?.status
      : isRunnerSuspended || isMarketSuspended
        ? isMarketSuspended
          ? "SUSPENDED"
          : item?.status
        : "OPEN";

    if (!isFancy) {
      if (status && status?.localeCompare("OPEN")) {
        return (
          <span className=" col-span-6 text-center min-h-12 py-[1px] px-[1px]">
            <span className="  text-center bg-bg_ballRunning cursor-not-allowed w-full h-full rounded-sm flex text-xs flex-col items-center justify-center">
              {isRacing && item?.status && item?.status != "ACTIVE"
                ? item?.status?.toUpperCase()
                : status?.toUpperCase()}
            </span>
          </span>
        );
      }

      return (
        <>
          {
            <span className="hidden md:block text-center min-h-12">
              <OddButton
                market={data}
                isBack={true}
                oddData={{ ...matchOddData?.back2, runner }}
                showEmpty
                centered
                showBlock={isRacing ? true : false}
                mainBlock={false}
                marketNum={2}
                setClicked={setClicked}
                clicked={clicked}
                isInactive={
                  data?.market_type != "MATCH_ODDS" ||
                  !!status?.localeCompare("OPEN")
                }
                inplay={inplay}
              />
            </span>
          }
          {
            <span className="hidden md:block text-center min-h-12">
              <OddButton
                market={data}
                isBack={true}
                oddData={{ ...matchOddData?.back1, runner }}
                showEmpty
                centered
                showBlock={isRacing ? true : false}
                mainBlock={false}
                marketNum={1}
                setClicked={setClicked}
                clicked={clicked}
                isInactive={
                  data?.market_type != "MATCH_ODDS" ||
                  !!status?.localeCompare("OPEN")
                }
                inplay={inplay}
              />
            </span>
          }

          <span className=" text-center min-h-12">
            <OddButton
              market={data}
              isBack={true}
              oddData={{ ...matchOddData?.back0, runner }}
              showEmpty
              centered
              showBlock={isRacing ? true : false}
              marketNum={0}
              setClicked={setClicked}
              clicked={clicked}
              isInactive={!!status?.localeCompare("OPEN")}
              inplay={inplay}
            />
          </span>

          <span className=" text-center min-h-12">
            <OddButton
              market={data}
              isBack={false}
              oddData={{ ...matchOddData?.lay0, runner }}
              showEmpty
              centered
              showBlock={isRacing ? true : false}
              marketNum={0}
              setClicked={setClicked}
              clicked={clicked}
              isInactive={!!status?.localeCompare("OPEN")}
              inplay={inplay}
            />
          </span>
          {
            <span className="hidden md:block text-center min-h-12">
              <OddButton
                market={data}
                isBack={false}
                oddData={{ ...matchOddData?.lay1, runner }}
                showEmpty
                centered
                showBlock={isRacing ? true : false}
                mainBlock={false}
                marketNum={1}
                setClicked={setClicked}
                clicked={clicked}
                isInactive={
                  data?.market_type != "MATCH_ODDS" ||
                  !!status?.localeCompare("OPEN")
                }
                inplay={inplay}
              />
            </span>
          }
          {
            <span className="hidden md:block text-center min-h-12">
              <OddButton
                market={data}
                isBack={false}
                oddData={{ ...matchOddData?.lay2, runner }}
                showEmpty
                centered
                showBlock={isRacing ? true : false}
                mainBlock={false}
                marketNum={2}
                setClicked={setClicked}
                clicked={clicked}
                isInactive={
                  data?.market_type != "MATCH_ODDS" ||
                  !!status?.localeCompare("OPEN")
                }
                inplay={inplay}
              />
            </span>
          }
        </>
      );
    }

    if (status && !!status?.localeCompare("OPEN")) {
      return (
        <span className=" col-span-4 text-center min-h-12 py-[1px] px-[1px]">
          <span className="  text-center bg-bg_ballRunning cursor-not-allowed w-full h-full rounded-sm flex text-xs flex-col items-center justify-center">
            {status?.toUpperCase()}
          </span>
        </span>
      );
    }

    return (
      <>
        {isFancy && (
          <span className=" text-center min-h-12 cols-span-1 md:col-span-2">
            <OddButton
              market={isFancy ? item : data}
              isBack={false}
              oddData={{ ...item, runner }}
              showEmpty
              centered
              isFancy={isFancy}
              category={item?.category}
              inplay={inplay}
            />
          </span>
        )}
        <span className=" text-center min-h-12 cols-span-1 md:col-span-2">
          <OddButton
            market={isFancy ? item : data}
            isBack={true}
            oddData={{ ...item, runner }}
            showEmpty
            centered
            isFancy={isFancy}
            category={item?.category}
            inplay={inplay}
          />
        </span>
      </>
    );
  };

  const openLadder = (name, id) => {
    if (exposureFancy && exposureFancy[id]) {
      actions.setSportLadderShow(true);
      actions.setSportLadderTitle(name);
      actions.setSportLadderId(id);
      actions.requestSportLadder(id);
    }
  };

  const renderExposure = (runnerId) => {
    let number = 0,
      calced;
    const pnlId = data.market_id;
    if (exposure && exposure && exposure[pnlId]) {
      let findNumber = exposure[pnlId]?.filter(
        (item) => item.selection_id == runnerId,
      );
      number = findNumber[0]?.user_pl;
    }

    let odds =
      data?.market_type === "BOOKMAKER"
        ? betPlacing.priceActual / 100 + 1
        : betPlacing.priceActual;
    if (betPlacing.market === data.market_id) {
      if (betPlacing.runner === runnerId) {
        if (betPlacing.isBack) {
          const profit = betPlacing.stake * odds - betPlacing.stake;
          calced = (isFancy ? 0 : number) + Number(profit) * (isFancy ? -1 : 1);
        } else {
          const profit = isFancy
            ? betPlacing.stake * (betPlacing.priceActual / 100)
            : (betPlacing.stake * odds - betPlacing.stake).toFixed(2);
          calced = (isFancy ? 0 : number) + Number(profit) * -1;
        }
      } else {
        calced = betPlacing.isBack
          ? number - Number(betPlacing.stake)
          : number - Number(betPlacing.stake) * -1;
        // calced = number - Number(betPlacing.stake)
      }
    }

    const preCalced =
      isFancy && number == 0 ? (
        <span className="text-[12px] font-bold from-neutral-600">
          {/* Max exposure:{" "} */}
        </span>
      ) : (
        ""
      );

    if (number || calced)
      return (
        <div className=" w-full flex items-center">
          {number ? (
            <div
              className={`text-[12px] font-bold ${
                number > 0 ? "text-text_Success" : "text-text_Danger"
              } whitespace-nowrap`}
            >
              {getCurrencyFormatRoundedOff(number)}
            </div>
          ) : null}
          {preCalced}
          {(calced || (number && calced == 0)) && (
            <div
              className={`text-[12px] font-bold ${
                calced > 0 ? "text-text_Success" : "text-text_Danger"
              }`}
            >
              &nbsp; &gt;&gt; {getCurrencyFormatRoundedOff(calced)}
            </div>
          )}
        </div>
      );

    return <span className="text-[12px] font-bold text-text_Success"></span>;
  };

  const renderExposureFancy = (runnerId) => {
    let number = 0,
      calced;
    const pnlId = data.fancy_id;
    if (exposureFancy && exposureFancy[pnlId]) number = exposureFancy[pnlId];
    if (betPlacing.market === data.fancy_id) {
      if (betPlacing.runner === runnerId) {
        if (betPlacing.isBack) {
          const profit = isFancy
            ? betPlacing.stake
            : (
                betPlacing.stake * betPlacing.priceActual -
                betPlacing.stake
              ).toFixed(2);
          calced = (isFancy ? 0 : number) + Number(profit) * (isFancy ? -1 : 1);
        } else {
          const profit = isFancy
            ? betPlacing.stake * (betPlacing.priceActual / 100)
            : (
                betPlacing.stake * betPlacing.priceActual -
                betPlacing.stake
              ).toFixed(2);
          calced = (isFancy ? 0 : number) + Number(profit) * -1;
        }
      } else {
        calced = betPlacing.isBack
          ? number - Number(betPlacing.stake)
          : number - Number(betPlacing.stake) * -1;
        // calced = number - Number(betPlacing.stake)
      }
    }

    // const preCalced =
    //   isFancy && number == 0 ? (
    //     <span className="text-[12px] font-bold from-neutral-600">
    //       Max exposure:{" "}
    //     </span>
    //   ) : (
    //     ""
    //   );

    if (number || calced)
      return (
        <div className=" w-full flex items-center">
          {number ? (
            <div
              className={`text-[12px] font-bold ${
                number > 0 ? "text-text_Success" : "text-text_Danger"
              } whitespace-nowrap`}
            >
              {getCurrencyFormatRoundedOff(number)}
            </div>
          ) : null}
          {/* {preCalced} */}
          {(calced || (number && calced == 0)) && (
            <div
              className={`text-[12px] font-bold  ${
                calced > 0 ? "text-text_Danger" : "text-text_Danger"
              }`}
            >
              {number ? <span className="ml-2 mr-1">{` >> `}</span> : null}
              {getCurrencyFormatRoundedOff(-1 * calced)}
            </div>
          )}
        </div>
      );
    return <span className="text-[12px] font-bold text-text_Success"></span>;
  };

  // const location = useLocation();
  // const navigate = useNavigate();

  // const eventTypeId = location?.pathname?.split("/")[2];
  // const eventId = history?.location?.pathname?.split("/")[3];
  // end get eventTypeId

  // const [activeIcon, setActiveIcon] = useState();
  const favoritesState = useSelector((state) => state.favorites);

  localStorage.setItem("favorites", JSON.stringify(favoritesState));

  // const isFavorite = () => {
  //   if (
  //     favoritesState?.favoritesAll?.length > 0 &&
  //     data &&
  //     favoritesState?.favoritesAll?.filter(
  //       (el) =>
  //         el?._id === data?._id &&
  //         (el?.marketId === data?.marketId ||
  //           el?.marketBook?.marketId === data?.marketId)
  //     ).length
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  // useEffect(() => {
  //   if (isFavorite()) {
  //     setActiveIcon(true);
  //   } else setActiveIcon(false);
  // }, [favoritesState, data]);

  const isAdvanced = !data?.user_setting_limit && !inplay;
  const isFancyMarket = !data?.user_setting_limit && inplay;

  // const marketMin = sportLimits?.check_event_limit
  //   ? sportLimits?.data[data?.market_id]?.market_min_stack
  //   : sportLimits?.IS_ADVANCE_EVENT_LIMIT_ENABLED_FOR_USER_WISE_MARKET
  //     ? data?.inplay
  //       ? sportLimits?.data?.market_advance_limites?.[data?.market_type]
  //           ?.market_min_stack
  //       : sportLimits?.data?.market_advance_limites?.[data?.market_type]
  //           ?.market_advance_bet_min_stake
  //     : sportLimits?.data?.market?.market_min_stack;

  // const marketMin = sportLimits?.check_event_limit
  //   ? sportLimits?.data[data?.market_id]?.market_min_stack
  //   : sportLimits?.IS_ADVANCE_EVENT_LIMIT_ENABLED_FOR_USER_WISE_MARKET
  //     ? data?.inplay
  //       ? sportLimits?.data?.market_advance_limites?.[data?.market_type]
  //           ?.market_min_stack
  //       : sportLimits?.data?.market_advance_limites?.[data?.market_type]
  //           ?.market_advance_bet_min_stake
  //     : sportLimits?.data?.market?.market_min_stack;

  const marketMin = isAdvanced
    ? getCurrencyFormat(data?.market_advance_bet_min_stake)
    : isFancyMarket
      ? getCurrencyFormat(data?.market_min_stack)
      : getCurrencyFormat(
          sportLimits?.check_event_limit
            ? sportLimits?.data[data?.market_id]?.market_min_stack
            : sportLimits?.IS_ADVANCE_EVENT_LIMIT_ENABLED_FOR_USER_WISE_MARKET
              ? data?.inplay
                ? sportLimits?.data?.market_advance_limites?.[data?.market_type]
                    ?.market_min_stack
                : sportLimits?.data?.market_advance_limites?.[data?.market_type]
                    ?.market_advance_bet_min_stake
              : sportLimits?.data?.market?.market_min_stack,
        );

  const marketMax = isAdvanced
    ? data?.market_advance_bet_stake
    : isFancyMarket
      ? data?.market_max_stack
      : sportLimits?.check_event_limit
        ? sportLimits?.data[data?.market_id]?.market_max_stack
        : sportLimits?.IS_ADVANCE_EVENT_LIMIT_ENABLED_FOR_USER_WISE_MARKET
          ? data?.inplay
            ? sportLimits?.data?.market_advance_limites?.[data?.market_type]
                ?.market_max_stack
            : sportLimits?.data?.market_advance_limites?.[data?.market_type]
                ?.market_advance_bet_stake
          : sportLimits?.data?.market?.market_max_stack;

  // const marketMax = sportLimits?.check_event_limit
  //   ? sportLimits?.data[data?.market_id]?.market_max_stack
  //   : sportLimits?.IS_ADVANCE_EVENT_LIMIT_ENABLED_FOR_USER_WISE_MARKET
  //     ? data?.inplay
  //       ? sportLimits?.data?.market_advance_limites?.[data?.market_type]
  //           ?.market_max_stack
  //       : sportLimits?.data?.market_advance_limites?.[data?.market_type]
  //           ?.market_advance_bet_stake
  //     : sportLimits?.data?.market?.market_max_stack;

  const fancyMin = isAdvanced
    ? data?.session_before_inplay_min_stack
    : isFancyMarket
      ? data?.session_min_stack
      : sportLimits?.check_event_limit
        ? sportLimits?.data?.session[data?.fancy_id]?.session_min_stack
        : sportLimits?.IS_ADVANCE_EVENT_LIMIT_ENABLED_FOR_USER_WISE_FANCY
          ? inplay
            ? sportLimits?.data?.session_advance_limites?.[data?.category]
                ?.session_min_stack
            : sportLimits?.data?.session_advance_limites?.[data?.category]
                ?.session_before_inplay_min_stack
          : sportLimits?.data?.session?.session_min_stack;
  const fancyMax = isAdvanced
    ? data?.session_before_inplay_max_stack
    : isFancyMarket
      ? data?.session_max_stack
      : sportLimits?.check_event_limit
        ? sportLimits?.data?.session[data?.fancy_id]?.session_max_stack
        : sportLimits?.IS_ADVANCE_EVENT_LIMIT_ENABLED_FOR_USER_WISE_FANCY
          ? inplay
            ? sportLimits?.data?.session_advance_limites?.[data?.category]
                ?.session_max_stack
            : sportLimits?.data?.session_advance_limites?.[data?.category]
                ?.session_before_inplay_max_stack
          : sportLimits?.data?.session?.session_max_stack;

  const renderFancy = (item) => {
    const runner = {
      id: item?.fancy_id,
      name: item?.fancy_name,
      status: item?.GameStatus
        ? item?.GameStatus
        : item?.is_active !== 1
          ? "SUSPENDED"
          : "OPEN",
    };

    const status = item?.GameStatus
      ? item?.GameStatus
      : item?.is_active !== 1
        ? "SUSPENDED"
        : "OPEN";

    return (
      <div
        key={`${item?.id}`}
        id={item?.id}
        className={`grid grid-cols-12  ${
          !isFancy && "border-b border-borderColorOfMarket"
        }`}
      >
        <div
          className={`w-full  ${
            isFancy ? "md:col-span-6" : "md:col-span-5"
          }  col-span-7 h-12 grid grid-cols-12 grid-flow-col pl-2.5 md:pl-2 py-0.5 pr-[3px]`}
        >
          <div
            className={` ${
              isFancy ? "col-span-10 md:col-span-11" : "truncate col-span-12"
            } flex items-start justify-center h-full flex-col`}
          >
            <div className=" w-full flex flex-nowrap gap-x-2 items-center">
              <span className=" truncate w-full capitalize text-text_Ternary  text-[13px] md:text-sm  font-semibold">
                {item?.fancy_name} {item?.category === 4 && "-"}{" "}
                {item?.category === 4 && item.LayPrice1}
              </span>
            </div>

            {renderExposureFancy(item?.selection_id)}
          </div>

          {isFancy ? (
            <>
              <span className=" col-span-2 md:col-span-1 flex flex-row items-center justify-center ">
                <div className="relative md:hidden">
                  <span
                    onClick={() => setShowInfo(!showInfo)}
                    className="w-4 h-4 bg-headerBg text-white rounded-full text-xs flex items-center justify-center cursor-pointer"
                  >
                    i
                  </span>

                  {showInfo && (
                    <div className="absolute shadow-[0_8px_30px_rgba(0,0,0,0.35)] top-full bg-[#ffffff] text-[#000000] mb-2 text-xs rounded whitespace-nowrap z-50 bg-[#ab082b] px-[12px] py-[5px]">
                      Min: {getCurrencyFormat(fancyMin)}
                      <br />
                      Max: {getCurrencyFormat(fancyMax)}
                    </div>
                  )}
                </div>
                <div
                  className={
                    openBets?.openBets?.some(
                      (myItem) => myItem.market_id == item?.fancy_id,
                    )
                      ? " cursor-pointer "
                      : " opacity-50 cursor-not-allowed"
                  }
                  onClick={() => {
                    if (
                      openBets?.openBets?.some(
                        (myItem) => myItem.market_id == item?.fancy_id,
                      )
                    ) {
                      openLadder(item?.fancy_name, item?.fancy_id);
                    }
                  }}
                >
                  <SVG_LadderIcon />
                </div>
              </span>
            </>
          ) : null}
        </div>
        <div
          className={` col-span-5 ${
            isFancy ? "md:col-span-6" : "md:col-span-7"
          }  h-12 grid grid-cols-2 md:grid-cols-6 relative`}
        >
          {status && !!status?.localeCompare("OPEN") ? (
            <span className=" col-span-4 text-center min-h-12 py-[1px] px-[1px]">
              <span className="  text-center bg-bg_ballRunning cursor-not-allowed w-full h-full rounded-sm flex text-xs flex-col items-center justify-center">
                {status?.toUpperCase()}
              </span>
            </span>
          ) : (
            <>{renderOdds(item, runner)}</>
          )}
          {isFancy && (
            <span className=" hidden md:block col-span-2 text-center min-h-12">
              <div className=" flex flex-col gap-y-1 items-center h-full w-full  justify-center  px-1">
                <div className=" flex items-center justify-center">
                  <span className=" text-[10px] text-center  text-text_MaxMarketTextColor">
                    Min Bet :
                  </span>
                  <span className=" text-[10px] text-center text-text_MaxMarketTextColor">
                    {" "}
                    {getCurrencyFormat(fancyMin)}
                  </span>
                </div>

                <div className=" flex items-center justify-start">
                  <span className=" text-[10px] text-center text-text_MaxMarketTextColor ">
                    Max Bet :
                  </span>
                  <span className=" text-[10px] text-center text-text_MaxMarketTextColor">
                    {" "}
                    {getCurrencyFormat(fancyMax)}
                  </span>
                </div>
              </div>
            </span>
          )}
        </div>

        <div className="col-span-12 h-max">
          {width < 1024 &&
            (isFancy
              ? betPlacing.market == item?.fancy_id
              : betPlacing.market == data?.marketId) &&
            status &&
            (isFancy || betPlacing.runner == runner.id) &&
            !status.localeCompare("OPEN") && (
              <span className=" col-span-12 h-max w-full">
                <BetPlacing onClose={() => {}} />
              </span>
            )}
        </div>
      </div>
    );
  };

  const formatCashout = (value) => {
    if (value < 1000) return value.toFixed(2);
    if (value < 100000) return (value / 1000).toFixed(2) + "K";
    return (value / 100000).toFixed(2) + " L";
  };

  // console.log(exposure?.[data?.market_id], data, "sdsaddsdasd");

  return (
    <div className={"py-1.5"}>
      {!isFancy && (
        <div className=" grid grid-flow-col grid-cols-12  text-xs font-[500] mb-1.5">
          <div className="pl-1 flex items-center justify-start gap-x-1 md:gap-x-1 col-span-7 md:col-span-5 ">
            <span className=" cursor-pointer transition-all ease-in-out duration-300 hover:scale-105"></span>
            <span className=" capitalize  text-text_HeaderDeskNavMenu font-bold text-xs sm:text-sm md:text-[15px]">
              {data?.market_name}
              <p className="text-[#7c7c7c] text-[10px]">
                Min:{getCurrencyFormat(marketMin)} | max:{" "}
                {getCurrencyFormat(marketMax)}
              </p>
            </span>

            {data?.runners?.length <= 2 &&
              (data?.market_type === "MATCH_ODDS" ||
                data?.market_type == "BOOKMAKER") && (
                <button
                  className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out bg-cashout-btn-gradient rounded-md px-2.5 py-1.5 text-center shadow-[inset_-12px_-8px_40px_#46464620] flex items-center justify-center flex-row h-max  max-w-[74%] mr-1 cursor-pointer"
                  type="button"
                  style={
                    cashOutData < 0
                      ? {
                          backgroundImage:
                            "linear-gradient(90deg, #0f2326, #bd3726)",
                        }
                      : {}
                  }
                  onClick={() => {
                    if (
                      openBets?.openBets?.some(
                        (item) => item.market_id === data.market_id,
                      )
                    ) {
                      sendCahsOutRequest(data, data.betDelay);
                    }
                  }}
                >
                  {/* Mobile View */}
                  <div className="block md:hidden text-[10px] md:text-sm text-white whitespace-nowrap text-center font-semibold">
                    Cashout {cashOutData != 0 && ":"}
                    {cashOutData != 0 && (
                      <div className="capitalize text-[10px] md:text-sm text-white whitespace-nowrap font-semibold">
                        <span>{formatCashout(cashOutData)}</span>
                      </div>
                    )}
                  </div>

                  {/* Desktop View */}
                  <div className="hidden md:flex text-[10px] md:text-sm text-white whitespace-nowrap text-center font-semibold">
                    Cashout {cashOutData != 0 && ":"}
                    {cashOutData != 0 && (
                      <div className="capitalize text-[10px] md:text-sm text-white whitespace-nowrap font-semibold">
                        <span>{formatCashout(cashOutData)}</span>
                      </div>
                    )}
                  </div>
                </button>
              )}

           
          </div>

          <div className=" col-span-5 md:col-span-7 grid grid-cols-2 md:grid-cols-6 pb-[2px]">
            <span className=" hidden md:flex col-span-1 text-center  font-semibold h-full  items-end justify-center"></span>
            <span className=" col-span-1 text-center  font-semibold h-full  hidden md:flex  items-end justify-center"></span>
            <span className=" col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 text-text_HeaderDeskNavMenu   font-bold h-full flex items-end justify-center">
              BACK
            </span>
            <span className=" col-span-1 text-center text-[10px] sm:text-xs md:text-sm  leading-3 text-text_HeaderDeskNavMenu  font-bold h-full flex items-end justify-center">
              LAY
            </span>
            <span className=" col-span-1 text-center font-semibold  h-full  hidden md:flex  items-end justify-center"></span>
            <span className=" col-span-1 text-center font-semibold  h-full  hidden md:flex  items-end justify-center"></span>
          </div>
        </div>
      )}

      <>
        <div className=" bg-bg_Quaternary rounded-[3px] shadow-[0_8px_30px_rgb(0,0,0,0.12)] py-[1px] cursor-pointer">
          {!isFancy &&
            data?.runners?.map((item, itemIndex) => {
              const runner = {
                id: !isFancy
                  ? item?.selectionId
                    ? item?.selectionId
                    : Array.isArray(data?.runners)
                      ? data?.runners[itemIndex]?.selectionId
                      : ""
                  : item?.fancy_id,
                name: !isFancy
                  ? item?.selection_name
                    ? item?.selection_name
                    : Array.isArray(data?.runners)
                      ? data?.runners[itemIndex]?.runnerName
                      : ""
                  : item?.fancy_name,
                status: !isFancy
                  ? item?.status != "ACTIVE" || data?.status != "OPEN"
                    ? "SUSPENDED"
                    : "OPEN"
                  : item?.status,
              };

              const status = isFancy ? item?.status : data?.status;

              const expHr = exposure?.[data?.market_id]?.find(
                (exp) => exp?.selection_id === item?.selectionId,
              );

              const isTobePlaced = data?.market_type == "TO_BE_PLACED";

              return (
                <div
                  key={`${item?.id}-${itemIndex}`}
                  id={item?.id}
                  className={`grid grid-cols-12  ${
                    itemIndex != data?.runners?.length - 1 &&
                    "border-b border-borderColorOfMarket"
                  }`}
                >
                  <div
                    className={`w-full  ${
                      isFancy ? "md:col-span-6" : "md:col-span-5"
                    }  col-span-7 h-12 grid grid-cols-12 grid-flow-col pl-2.5 md:pl-2 py-0.5 pr-[3px]`}
                  >
                    <div
                      className={` ${
                        isFancy
                          ? "col-span-8 md:col-span-10"
                          : "truncate col-span-12"
                      } flex items-start justify-center h-full flex-col`}
                    >
                      <div className=" w-full flex flex-nowrap gap-x-2 items-center">
                        {data.sport_id == 7 && (
                          <div
                            onClick={() => addMarketData(item)}
                            className={
                              !selectedRaces.some(
                                (itemSelect) =>
                                  itemSelect.selectionId === item.selectionId,
                              )
                                ? "topFilters-item-check"
                                : "topFilters-item-check checked"
                            }
                          ></div>
                        )}

                        {data.sport_id == 7 && (
                          <div className=" flex items-center justify-center  flex-col text-text_color_primary1">
                            {data?.runners[itemIndex]?.metadata
                              ?.CLOTH_NUMBER && (
                              <span className="text-xs font-[400]">
                                (
                                {
                                  data?.runners[itemIndex]?.metadata
                                    ?.CLOTH_NUMBER
                                }
                                )
                              </span>
                            )}
                          </div>
                        )}

                        {isRacing &&
                          data?.runners[itemIndex]?.metadata
                            ?.COLOURS_FILENAME && (
                            <div className="relative overflow-hidden  w-[20px] h-[20px] mr-[6px] col-span-3">
                              <img
                                src={
                                  data?.runners[itemIndex]?.metadata
                                    ?.COLOURS_FILENAME
                                }
                                alt="Obed Sanchez"
                                sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 625px"
                                className=" bg-bg_color_skeletonBgLoaderColor1 w-[20px] h-[20px]"
                                title="Obed Sanchez"
                              />
                            </div>
                          )}

                        {isRacing && data?.runners[itemIndex]?.metadata ? (
                          <div className="col-span-7 w-full flex flex-col text-text_color_primary1">
                            <div className="w-full text-xs md:text-sm font-[400]">
                              {data?.runners[itemIndex]?.metadata
                                ?.JOCKEY_NAME ||
                                item?.selection_name ||
                                data?.runners[itemIndex]?.runnerName ||
                                data?.competitionName}
                            </div>
                            <span className="text-[10px]">
                              {data?.runners[itemIndex]?.metadata?.TRAINER_NAME}
                            </span>
                          </div>
                        ) : (
                          <span className=" truncate w-full capitalize text-text_Ternary  text-[13px] md:text-sm  font-semibold">
                            {isFancy
                              ? item?.marketName
                              : isRacing
                                ? data?.runners[itemIndex]?.metadata
                                  ? data?.runners[itemIndex]?.metadata
                                      ?.JOCKEY_NAME
                                  : item?.selection_name ||
                                    data?.runners[itemIndex]?.runnerName ||
                                    data?.competitionName
                                : item?.selection_name ||
                                  data?.runners[itemIndex]?.runnerName ||
                                  data?.competitionName}
                          </span>
                        )}
                        {isTobePlaced ? (
                          <div>
                            {expHr?.win_value !== 0 && (
                              <div
                                className={`text-[12px] text-end font-bold ${
                                  expHr?.win_value > 0
                                    ? "text-text_Success"
                                    : "text-text_Danger"
                                } whitespace-nowrap`}
                              >
                                {expHr?.win_value}
                              </div>
                            )}
                            {expHr?.loss_value !== 0 && (
                              <div
                                className={`text-[12px] text-end font-bold ${
                                  expHr?.loss_value > 0
                                    ? "text-text_Success"
                                    : "text-text_Danger"
                                } whitespace-nowrap`}
                              >
                                {expHr?.loss_value}
                              </div>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      {!isTobePlaced && renderExposure(runner?.id)}
                    </div>

                    {isFancy ? (
                      <>
                        {!!betPlacing?.betDelay?.fancyBetDelay && (
                          <span className=" col-span-2 md:col-span-1 flex flex-row items-center justify-center gap-x-[2px]">
                            <SVG_StopWatchtIcon />
                            <span className=" font-[480] text-sm text-text_Ternary ">
                              {betPlacing?.betDelay?.fancyBetDelay}s
                            </span>
                          </span>
                        )}
                        <span className=" col-span-2 md:col-span-1 flex flex-row items-center justify-center">
                          <div
                            className={
                              openBets?.openBets?.some(
                                (myItem) => myItem.market_id == item?.market_id,
                              )
                                ? " cursor-pointer "
                                : " opacity-50 cursor-not-allowed"
                            }
                            onClick={() => {
                              if (
                                openBets?.openBets?.some(
                                  (myItem) =>
                                    myItem.market_id == item?.market_id,
                                )
                              ) {
                                openLadder(item);
                              }
                            }}
                          >
                            <SVG_LadderIcon />
                          </div>
                        </span>
                      </>
                    ) : null}
                  </div>

                  <div
                    className={` col-span-5 ${
                      isFancy ? "md:col-span-6" : "md:col-span-7"
                    }  h-12 grid grid-cols-2 md:grid-cols-6 relative`}
                  >
                    {renderOdds(item, runner)}

                    {isFancy && (
                      <span className=" hidden md:block col-span-2 text-center min-h-12">
                        <div className=" flex flex-col gap-y-1 items-center h-full w-full  justify-center  px-1">
                          <div className=" flex items-center justify-center">
                            <span className=" text-[10px] text-center  text-text_MaxMarketTextColor">
                              Min Bet :
                            </span>
                            <span className=" text-[10px] text-center text-text_MaxMarketTextColor">
                              {" "}
                              {getCurrencyFormat(fancyMin)}
                            </span>
                          </div>

                          <div className=" flex items-center justify-start">
                            <span className=" text-[10px] text-center text-text_MaxMarketTextColor ">
                              Max Bet :
                            </span>
                            <span className=" text-[10px] text-center text-text_MaxMarketTextColor">
                              {" "}
                              {/* {getCurrencyFormat(
                                data?.session_live_odds_validation
                                  ? data?.Max
                                  : sportLimits?.check_event_limit
                                    ? sportLimits?.data?.session[data?.fancy_id]
                                        ?.session_max_stack
                                    : sportLimits?.data?.session
                                        ?.session_max_stack,
                              )} */}
                              {getCurrencyFormat(fancyMax)}
                            </span>
                          </div>
                        </div>
                      </span>
                    )}
                  </div>

                  <div className="col-span-12 h-max">
                    {width < 1024 &&
                      (isFancy
                        ? betPlacing.market == item?.fancy_id
                        : betPlacing.market == data?.market_id) &&
                      status &&
                      (isFancy || betPlacing.runner == runner.id) &&
                      !status.localeCompare("OPEN") &&
                      !cashoutPopUp?.isOpen && (
                        <span className=" col-span-12 h-max w-full">
                          <BetPlacing onClose={() => {}} />
                        </span>
                      )}
                  </div>
                </div>
              );
            })}

          {isFancy && data && renderFancy(data)}
        </div>
        {data?.news && (
          <Marquee speed={20}>
            <p
              className="marquee-scroll w-full text-[#c10931] text-[12px] text-end"
              style={{
                animationDuration: "25s",
                animationPlayState: "running",
              }}
            >
              {data?.news}
            </p>
          </Marquee>
        )}
      </>
    </div>
  );
};

export default connectSportMarketStandard()(SportMarketStandard);
